import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSuccess(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#Success_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#Success_svg__b)" strokeWidth={20} />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="m73.556 62.576 9.333 9.545 21.778-25.454"
        />
      </g>
      <defs>
        <linearGradient
          id="Success_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="Success_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;
